var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "left" }, [
      _c("div", { staticClass: "title" }, [_vm._v("重开采购入库单")]),
      _c(
        "div",
        { staticClass: "leftContext" },
        [
          _c(
            "el-table",
            { attrs: { data: _vm.table.list } },
            [
              _c("el-table-column", {
                attrs: { label: "序号", type: "index", width: "55" },
              }),
              _c("el-table-column", { attrs: { label: "创建时间" } }),
              _c("el-table-column", { attrs: { label: "供应商" } }),
              _c("el-table-column", { attrs: { label: "创建人" } }),
              _c("el-table-column", { attrs: { label: "入库部门" } }),
              _c("el-table-column", { attrs: { label: "入库仓库" } }),
              _c("el-table-column", {
                attrs: {
                  label: "入库商品",
                  "show-overflow-tooltip": "",
                  "min-width": "120px;",
                },
              }),
              _c("el-table-column", { attrs: { label: "商品类型" } }),
              _c("el-table-column", { attrs: { label: "商品图片" } }),
              _c("el-table-column", { attrs: { label: "入库品牌" } }),
              _c("el-table-column", { attrs: { label: "采购数量" } }),
              _c("el-table-column", { attrs: { label: "入库规格" } }),
              _c("el-table-column", { attrs: { label: "入库单价" } }),
              _c("el-table-column", { attrs: { label: "入库金额" } }),
              _c("el-table-column", { attrs: { label: "入库数量" } }),
              _c("el-table-column", {
                attrs: { label: "未入库数量", "min-width": "120px" },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "right" }, [
      _c("div", { staticClass: "title" }, [_vm._v("操作")]),
      _c(
        "div",
        { staticClass: "rightContext", staticStyle: { border: "0" } },
        [
          _c(
            "el-form",
            { ref: "form", attrs: { model: _vm.form, "label-width": "80px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "入库部门" } },
                [
                  _c("el-input", {
                    attrs: { size: "small", placeholder: "请输入入库部门" },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "入库类型" } },
                [
                  _c("el-input", {
                    attrs: { size: "small", placeholder: "请输入入库类型" },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "入库商品" } },
                [
                  _c("el-input", {
                    attrs: { size: "small", placeholder: "请输入入库商品" },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "入库规格" } },
                [
                  _c("el-input", {
                    attrs: { size: "small", placeholder: "请输入入库规格" },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "入库品牌" } },
                [
                  _c("el-input", {
                    attrs: { size: "small", placeholder: "请输入入库品牌" },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "采购数量" } },
                [
                  _c("el-input", {
                    attrs: { size: "small", placeholder: "请输入采购数量" },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "入库数量" } },
                [
                  _c("el-input", {
                    attrs: { size: "small", placeholder: "请输入入库数量" },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "入库仓库" } },
                [
                  _vm._l(_vm.selectObj.warehouses, function (ite, index) {
                    return ite.type == 0 || ite.type == undefined
                      ? _c(
                          "div",
                          {
                            key: index,
                            staticStyle: {
                              display: "flex",
                              "justify-content": "space-between",
                              "align-items": "center",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  value: ite.warName,
                                  size: "mini",
                                  "value-key": "id",
                                  placeholder: "请选择",
                                  disabled: ite.type == 0,
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.myWareListChange($event, ite)
                                  },
                                },
                              },
                              _vm._l(_vm.wareList.list, function (item) {
                                return _c("el-option", {
                                  key: item.id,
                                  attrs: { label: item.name, value: item },
                                })
                              }),
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center",
                                },
                              },
                              [
                                _c("el-input-number", {
                                  staticStyle: { "margin-right": "10px" },
                                  attrs: {
                                    size: "mini",
                                    min: 0,
                                    placeholder: "请输入库存数量",
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.inputChange(ite)
                                    },
                                  },
                                  model: {
                                    value: ite.laterQuantity,
                                    callback: function ($$v) {
                                      _vm.$set(ite, "laterQuantity", $$v)
                                    },
                                    expression: "ite.laterQuantity",
                                  },
                                }),
                                _c("i", {
                                  staticClass: "el-icon-remove-outline",
                                  staticStyle: { cursor: "pointer" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.deleteMyWare(
                                        ite,
                                        ite.type != undefined ? 1 : 0
                                      )
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e()
                  }),
                  _c("i", {
                    staticClass: "el-icon-circle-plus-outline",
                    staticStyle: { cursor: "pointer" },
                    on: { click: _vm.addMyWareList },
                  }),
                ],
                2
              ),
              _c(
                "el-form-item",
                { attrs: { label: "上传图片" } },
                [
                  _c(
                    "el-upload",
                    {
                      ref: "upload",
                      staticClass: "video",
                      attrs: {
                        action: "#",
                        multiple: "",
                        "before-upload": _vm.beforeUploadImg,
                        "http-request": _vm.imgUpload,
                        "show-file-list": false,
                      },
                    },
                    [
                      _c(
                        "el-button",
                        { attrs: { type: "primary", size: "mini" } },
                        [_vm._v("选择图片")]
                      ),
                    ],
                    1
                  ),
                  _vm._l(_vm.fileListImg, function (itemsImg, index) {
                    return _vm.fileListImg
                      ? _c("div", { staticClass: "liimg" }, [
                          itemsImg
                            ? _c("img", {
                                directives: [
                                  {
                                    name: "image-preview",
                                    rawName: "v-image-preview",
                                  },
                                ],
                                staticClass: "img-avatar",
                                attrs: { src: _vm.ImgHttps + itemsImg.img },
                              })
                            : _vm._e(),
                          itemsImg
                            ? _c("p", [_vm._v(_vm._s(itemsImg.creattime))])
                            : _vm._e(),
                          itemsImg
                            ? _c(
                                "p",
                                {
                                  staticClass: "close",
                                  on: {
                                    click: function ($event) {
                                      return _vm.delectImgList(index)
                                    },
                                  },
                                },
                                [_c("i", { staticClass: "el-icon-error" })]
                              )
                            : _vm._e(),
                        ])
                      : _vm._e()
                  }),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }